import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

export const Intro = () => {
  const [show, setShow] = useState(() => {
    try {
      return !sessionStorage.getItem("leno_intro_seen");
    } catch {
      return false;
    }
  });
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    if (!show) return;
    document.body.style.overflow = "hidden";
    const t1 = setTimeout(() => setLeaving(true), 2000);
    const t2 = setTimeout(() => {
      setShow(false);
      document.body.style.overflow = "";
      try {
        sessionStorage.setItem("leno_intro_seen", "1");
      } catch {
        /* privat-Modus */
      }
    }, 2900);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      document.body.style.overflow = "";
    };
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          animate={leaving ? { opacity: 0, transition: { duration: 0.9, ease: "easeInOut" } } : {}}
          className="fixed inset-0 z-[90] flex flex-col items-center justify-center bg-ink"
          data-testid="intro-overlay"
          aria-hidden="true"
        >
          <div className="flex overflow-hidden">
            {"LENO".split("").map((ch, i) => (
              <motion.span
                key={i}
                initial={{ y: "110%", opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.25 + i * 0.12, duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
                className="font-serif text-6xl font-light tracking-[0.08em] text-white sm:text-8xl"
              >
                {ch}
              </motion.span>
            ))}
          </div>
          <motion.div
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ delay: 0.9, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className="mt-6 h-px w-40 origin-center bg-gold sm:w-56"
          />
          <motion.p
            initial={{ opacity: 0, letterSpacing: "0.2em" }}
            animate={{ opacity: 1, letterSpacing: "0.55em" }}
            transition={{ delay: 1.1, duration: 0.9 }}
            className="mt-5 font-mono text-[10px] uppercase text-gold"
          >
            Fotografie
          </motion.p>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
